import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

@Component({
    selector: 'app-percentage-bar',
    templateUrl: './percentage-bar.component.html',
    styleUrls: ['./percentage-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PercentageBarComponent implements OnInit {
  @Input() percentage: number;
  @Input() label: string;

  constructor() {}

  ngOnInit(): void {}
}
